unit RemittancesListPage;

interface

uses
  System.SysUtils,
  System.Classes,
  JS,
  Web,
  WEBLib.Graphics,
  WEBLib.Controls,
  WEBLib.Forms,
  WEBLib.Dialogs,
  BaseListNoGrid,
  WEBLib.ExtCtrls,
  WEBLib.Actions,
  Data.DB,
  WEBLib.DB,
  XData.Web.JsonDataset,
  XData.Web.Dataset,
  Vcl.StdCtrls,
  WEBLib.StdCtrls,
  WEBLib.Grids,
  WEBLib.DBCtrls,
  Vcl.Controls,
  WEBLib.Lists,
  smx.webcore.types,
  XData.Web.Client,
  Types,
  WEBLib.WebCtrls,
  RemittanceList.DTO;

type
  TRemittanceListForm = class(TBaseListNoGridForm)
    procedure WebFormShow(Sender: TObject);
    procedure DataTableGetCellChildren(Sender: TObject; ACol, ARow: Integer;
      AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure DataTableGetCellData(Sender: TObject; ACol, ARow: Integer;
      AField: TField; var AValue: string);
  private
    { Private declarations }
    FSortField: string; // Base field name (e.g., 'RemittanceDate')
    FSortDirection: string; // 'ASC' or 'DESC'

    function ConvertDTOToJSArray(const AResponse: TRemittanceListResponse): TJSArray;
    procedure HandleHeaderClick(const AColumnTitle: string);
    function OnHandleHeaderClick(Event: TJSMouseEvent): Boolean;

  protected
    procedure PrepareForm; override;

    [async]
    procedure LoadData; async; override;
    function GetEditFormClass: TFormClass; override;

    [async]
    procedure EditRecord(const ARecordId: string); async; override;
    procedure AddRowActions(const ARecordId: string; AParentElement: TJSHTMLElement); override;

    [async]
    procedure DeleteRecord(const ARecordId: string); async;

    [async]
    procedure PerformDelete(const ARecordId: string); async;

    procedure GenerateFieldDefs; override;

  public
    { Public declarations }
  protected procedure LoadDFMValues; override; end;

var
  RemittanceListForm: TRemittanceListForm;

implementation

{$R *.dfm}

uses
  RemittancesEditPage,
  MainDataModule,
  smx.Web.Layout.Utils,
  Web.Remittance.Utils;

procedure TRemittanceListForm.PrepareForm;
begin
  // set the id field
  IdField := 'Id';

  // ensure the data connection is assigned since the IDE has a tendency to remove it
  DataConnection := MainData.DataConnection;

  // configure the JSON dataset and table
  MainDataSource.DataSet := JSONDataset;
  DataTable.DataSource := MainDataSource;

  // Initialize default sort
  FSortField := 'RemittanceDate';
  FSortDirection := 'ASC';

end;

procedure TRemittanceListForm.GenerateFieldDefs;
begin
  // generate field definitions for JSON dataset
  AddFieldDef('Id', ftInteger);
  AddFieldDef('RemittanceDate', ftString, 20);
  AddFieldDef('PaymentState', ftString, 20);
  AddFieldDef('PaymentRef', ftString, 50);
  AddFieldDef('InvoiceRef', ftString, 50);

  // generate column definitions for table display
  AddColumnDef('Id', 'ID', 60);
  AddColumnDef('RemittanceDate', 'Remittance Date', 120);
  AddColumnDef('PaymentState', 'Payment State', 100);
  AddColumnDef('PaymentRef', 'Payment Ref', 150);
  AddColumnDef('InvoiceRef', 'Invoice Ref', 150);
  // empty data field for Actions column
  AddColumnDef('', 'Actions', 150);

end;

procedure TRemittanceListForm.WebFormShow(Sender: TObject);
begin
  inherited;

  // Load the data
  try
    RefreshData;

  except
    on E: Exception do
    begin
      MainData.DebugLog('Error in RefreshData: ' + E.Message);

    end;

  end;

end;

procedure TRemittanceListForm.LoadData;
var
  oResponse: TRemittanceListResponse;
  oClientResponse: TXDataClientResponse;
  oResult: TJSObject;
  oItems: TJSArray;
  oJSONData: TJSArray;
  iIdx: Integer;
  oItem: TJSObject;
  oRemittance: TRemittanceListDTO;

begin
  // use the DTO service method for getting remittances
  if MainData.WebClient <> nil then
  begin
    try
      // call the DTO service method with pagination parameters
      oClientResponse := Await(
        TXDataClientResponse,
        MainData.WebClient.RawInvokeAsync('IRemittanceDTOService.GetRemittanceList', [
          PageSize,     // current page size
          CurrentPage,  // current page
          SearchText,   // current search text
          BuildRemittanceOrderByParameter(FSortField, FSortDirection),
          ''            // filter
        ])
      );
      oResult := oClientResponse.ResultAsObject;

      if oResult <> nil then
      begin
        oResponse := TRemittanceListResponse.Create;
        
        // extract pagination info
        oResponse.TotalCount := JS.toInteger(oResult['TotalCount']);
        oResponse.PageSize := JS.toInteger(oResult['PageSize']);
        oResponse.CurrentPage := JS.toInteger(oResult['CurrentPage']);
        oResponse.TotalPages := JS.toInteger(oResult['TotalPages']);

        // extract items array and populate the DTO response
        oItems := TJSArray(oResult['Items']);
        for iIdx := 0 to oItems.Length - 1 do
        begin
          oItem := TJSObject(oItems[iIdx]);
          oRemittance := TRemittanceListDTO.Create;
          
          oRemittance.Id := JS.toInteger(oItem['Id']);
          oRemittance.InvoiceId := JS.toInteger(oItem['InvoiceId']);
          oRemittance.SchoolId := JS.toInteger(oItem['SchoolId']);
          oRemittance.PaymentRef := JS.toString(oItem['PaymentRef']);
          oRemittance.PaymentState := JS.toString(oItem['PaymentState']);
          oRemittance.PaymentMethod := JS.toString(oItem['PaymentMethod']);
          oRemittance.PaymentKind := JS.toString(oItem['PaymentKind']);
          oRemittance.Amount := JS.toNumber(oItem['Amount']);

          // process dates - set to 0 if null or invalid
          oRemittance.RemittanceDate := GetValidRemittanceDate(
            GetRemittanceDateFromString(JS.toString(oItem['RemittanceDate'])));

          oRemittance.InvoiceRef := JS.toString(oItem['InvoiceRef']);
          
          oResponse.Items.Add(oRemittance);

        end;
        
        oJSONData := ConvertDTOToJSArray(oResponse);

        // load the JSON data into the dataset
        try
          JSONDataset.SetJsonData(oJSONData);

        except
          on E: Exception do
          begin
            console.log('Error setting JSON data: ' + E.Message);
            Exit;

          end;

        end;

        // open the dataset
        try
          JSONDataset.Open;

        except
          on E: Exception do
          begin
            console.log('Error opening dataset: ' + E.Message);
            Exit;

          end;

        end;
        
        // update pagination info
        SetTotalRecords(oResponse.TotalCount);
        UpdatePagination;
        
        // Enable controls after data is loaded
        UnLockControls(True);
        
        oResponse.Free;

      end
      else
      begin
        console.log('No data received from server');
        UnLockControls(True);

      end;

    except
      on E: Exception do
      begin
        console.log('Error loading data: ' + E.Message);
        UnLockControls(True);

      end;

    end;

  end
  else
  begin
    console.log('WebClient not available');
    UnLockControls(True);

  end;

end;

procedure TRemittanceListForm.DataTableGetCellChildren(Sender: TObject; ACol,
  ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  sRecordId: string;
  oDiv: TJSHTMLElement;
  sCurrentHTML: string;
  sColumnTitle: string;
  sOrderByField: string;

begin
  inherited;

  if Sender is TDBTableControl then
  begin
    // Handle header row - make columns sortable
    if ARow = 0 then
    begin
      sColumnTitle := DataTable.Columns[ACol].Title;
      // Make sortable columns clickable (exclude Actions column)
      if (sColumnTitle <> 'Actions') and (sColumnTitle <> '') then
      begin
        sOrderByField := GetRemittanceOrderByFieldName(sColumnTitle);
        if sOrderByField <> '' then
        begin
          // Make header clickable
          AElement.Element.style.setProperty('cursor', 'pointer');
          AElement.Element.style.setProperty('user-select', 'none');
          
          // Add sort indicator
          if FSortField = sOrderByField then
          begin
            if FSortDirection = 'ASC' then
              AElement.Element.innerHTML := sColumnTitle + ' <i class="fas fa-sort-up"></i>'
            else
              AElement.Element.innerHTML := sColumnTitle + ' <i class="fas fa-sort-down"></i>';

          end
          else
            AElement.Element.innerHTML := sColumnTitle + ' <i class="fas fa-sort" style="opacity: 0.3; color: #ccc;"></i>';

          // Store column title in data attribute for handler access
          AElement.Element.setAttribute('data-column-title', sColumnTitle);
          
          // Add click handler
          AElement.Element.onclick := @OnHandleHeaderClick;

        end;

      end;

    end
    else
    begin
      // wrap cell content in div with overflow styles for data rows (not header)
      if DataTable.Columns[ACol].Title <> 'Actions' then
      begin
        sCurrentHTML := string(AElement.Element.innerHTML);
        // only wrap if not already wrapped
        if (sCurrentHTML <> '') and (Pos('<div style="overflow:', sCurrentHTML) = 0) then
        begin
          oDiv := TJSHTMLElement(document.createElement('div'));
          oDiv.style.setProperty('overflow', 'hidden');
          oDiv.style.setProperty('text-overflow', 'ellipsis');
          oDiv.style.setProperty('white-space', 'nowrap');
          oDiv.innerHTML := sCurrentHTML;
          AElement.Element.innerHTML := '';
          AElement.Element.appendChild(oDiv);

        end;

      end;

    end;

  end;

  // add row actions
  if (DataTable.Columns[ACol].Title = 'Actions') and (ARow <> 0) then
  begin
    sRecordId := JSONDataset.FieldByName(IdField).AsString;
    AddRowActions(sRecordId, AElement.Element);

  end;

end;

procedure TRemittanceListForm.DataTableGetCellData(Sender: TObject; ACol,
  ARow: Integer; AField: TField; var AValue: string);
begin
  inherited;

  if Sender is TDBTableControl then
  begin
    // format data if available, otherwise clear field
    if Assigned(AField) then
    begin
      if AField.IsNull then
        AValue := ''
      else
        AValue := AField.AsString;

    end
    else
    begin
      // don't clear header row
      if ARow <> 0 then
        AValue := '';

    end;

  end;

end;

function TRemittanceListForm.GetEditFormClass: TFormClass;
begin
  Result := TRemittanceEditForm;

end;

procedure TRemittanceListForm.EditRecord(const ARecordId: string);
var
  oForm: TRemittanceEditForm;

begin
  // load list of schools, loading invoices relies upon the school being selected
  Await(MainData.OpenSchoolLookUp);

  // prepare data set
  if ARecordId = ''  then
  begin
    Await(MainData.LoadRemittances);

    if not MainData.RemittanceLookup.Active then
      MainData.RemittanceLookup.Open;
    MainData.RemittanceLookup.Append;

  end
  else
  begin
    // Load the specific remittance by ID - LoadRemittanceById will ensure dataset is active
    try
      Await(MainData.LoadRemittanceById(ARecordId.ToInteger));

    except
      on E: Exception do
      begin
        ShowMessage('Failed to load remittance dataset: ' + E.Message);
        Exit;

      end;

    end;
    
    if MainData.RemittanceLookup.RecordCount = 0 then
    begin
      ShowMessage('Remittance record not found (ID: ' + ARecordId + ')');
      Exit;

    end;
    
    // Ensure we're positioned on the record (should be first/only one after filtering by ID)
    if not (MainData.RemittanceLookup.Bof and MainData.RemittanceLookup.Eof) then
      MainData.RemittanceLookup.First;
      
    // Verify the dataset has a valid record - this also ensures JSON structure is initialized
    try
      if MainData.RemittanceLookup.FieldByName('Id').AsInteger <> ARecordId.ToInteger then
      begin
        ShowMessage('Remittance record ID mismatch');
        Exit;

      end;

    except
      on E: Exception do
      begin
        ShowMessage('Error accessing remittance record: ' + E.Message);
        Exit;

      end;

    end;

  end;

  // show the edit form
  oForm := TRemittanceEditForm.Create(Self);
  try
    oForm.Popup := True;
    oForm.PopupOpacity := 1;
    await(TRemittanceEditForm, oForm.Load());
    oForm.IdField := IdField;
    oForm.RecordViewOption := Self.RecordViewOption;

    // Set the dataset - it should be fully loaded, active, and positioned at this point
    oForm.Dataset := MainData.RemittanceLookup;
    oForm.IsInsert := ARecordId = '';
    
    // Initialize the form after dataset is set (needed for dropdowns and lookups)
    await(oForm.InitForm);
    
    await(TModalResult, oForm.Execute);

  finally
    oForm.Free;
    oForm := nil;

  end;
    
  // Refresh data after editing
  RefreshData;

end;


procedure TRemittanceListForm.AddRowActions(const ARecordId: string; AParentElement: TJSHTMLElement);

  procedure DeleteClick(Sender: TObject);
  begin
    DeleteRecord(ARecordId);
  end;

var
  Span: THTMLSpan;

begin
  inherited;

  if (RecordViewOption in [voEdit, voCreateAndEdit]) then
  begin
    Span := TLayoutUtils.RowActionSpan(AParentElement, 'fad fa-trash fa-fw fa-lg', 'Delete');
    Span.OnClick := @DeleteClick;

  end;

end;

procedure TRemittanceListForm.DeleteRecord(const ARecordId: string);
begin
  MessageDlg(
    'This will permanently remove the remittance, are you sure you wish to proceed?',
    mtConfirmation,
    [mbYes, mbNo],
    procedure(Res: TModalResult)
    begin
      if Res = mrYes then
      begin
        PerformDelete(ARecordId);

      end;

    end
  );

end;

procedure TRemittanceListForm.PerformDelete(const ARecordId: string);
var
  nPaymentId: Integer;
  oClientResponse: TXDataClientResponse;
  jsoResponse: TJSObject;
  bSuccess: Boolean;
  sMessage: string;

begin
  if ARecordId = '' then
    Exit;

  nPaymentId := StrToIntDef(ARecordId, 0);
  if nPaymentId <= 0 then
  begin
    console.log('Invalid payment ID: ' + ARecordId);
    Exit;

  end;

  // Call the MoneyService to delete the payment
  if MainData.WebClient <> nil then
  begin
    try
      oClientResponse := Await(
        TXDataClientResponse,
        MainData.WebClient.RawInvokeAsync('IMoneyService.DeletePayment', [nPaymentId])
      );

      jsoResponse := oClientResponse.ResultAsObject;
      bSuccess := Boolean(jsoResponse['value']);

      if bSuccess then
        sMessage := 'Remittance deleted successfully'
      else
        sMessage := 'Failed to delete remittance';

      ShowMessage(sMessage);

    except
      on E: Exception do
      begin
        console.log('Error deleting payment: ' + E.Message);
        DisplayMessage('Error deleting payment: ' + E.Message, mtError);

      end;

    end;

  end
  else
  begin
    console.log('WebClient not available');
    DisplayMessage('WebClient not available', mtError);

  end;

  // Refresh the data after successful deletion
  RefreshData;

end;

function TRemittanceListForm.ConvertDTOToJSArray(const AResponse: TRemittanceListResponse): TJSArray;
var
  nI: Integer;
  oRemittance: TRemittanceListDTO;
  oItem: TJSObject;

begin
  Result := TJSArray.new;
  
  if Assigned(AResponse) and Assigned(AResponse.Items) then
  begin
    for nI := 0 to AResponse.Items.Count - 1 do
    begin
      try
        oRemittance := AResponse.Items[nI];
        oItem := TJSObject.new;
        
        oItem['Id'] := oRemittance.Id;
        oItem['PaymentRef'] := oRemittance.PaymentRef;
        oItem['PaymentState'] := oRemittance.PaymentState;
        oItem['InvoiceRef'] := oRemittance.InvoiceRef;
        
        oItem['RemittanceDate'] := FormatRemittanceDateForDisplay(oRemittance.RemittanceDate);
        
        Result.push(oItem);

      except
        on E: Exception do
        begin
          console.log('Error converting item ' + IntToStr(nI) + ': ' + E.Message);

        end;

      end;

    end;

  end;

end;

procedure TRemittanceListForm.HandleHeaderClick(const AColumnTitle: string);
var
  sNewSortField: string;
  sNewSortDirection: string;

begin
  if not ApplyListSortToggle(FSortField, FSortDirection, AColumnTitle,
    sNewSortField, sNewSortDirection) then
    Exit;

  FSortField := sNewSortField;
  FSortDirection := sNewSortDirection;
  
  // Reset to first page when sorting changes
  CurrentPage := 1;
  
  // Reload data with new sort
  RefreshData;

end;

function TRemittanceListForm.OnHandleHeaderClick(Event: TJSMouseEvent): Boolean;
var
  oTarget: TJSHTMLElement;
  sColumnTitle: string;

begin
  Result := False;
  
  // Get the target element (the header cell)
  oTarget := TJSHTMLElement(Event.target);
  
  // Find the th element if we clicked on a child element (like the icon)
  while (oTarget <> nil) and (oTarget.tagName <> 'TH') do
    oTarget := TJSHTMLElement(oTarget.parentElement);
  
  if oTarget <> nil then
  begin
    // Retrieve column title from data attribute
    sColumnTitle := string(oTarget.getAttribute('data-column-title'));
    
    if sColumnTitle <> '' then
    begin
      HandleHeaderClick(sColumnTitle);
      Result := True; // Prevent default behavior

    end;

  end;

end;

procedure TRemittanceListForm.LoadDFMValues;
begin
  inherited LoadDFMValues;


  DataTable.BeforeLoadDFMValues;
  try
    Name := 'RemittanceListForm';
    SetEvent(Self, 'OnShow', 'WebFormShow');
    DataTable.ElementHeaderClassName := 'thead-light';
    DataTable.ElementTableClassName := 'table table-striped table-bordered  table-hover';
    SetEvent(DataTable, Self, 'OnGetCellData', 'DataTableGetCellData');
    SetEvent(DataTable, Self, 'OnGetCellChildren', 'DataTableGetCellChildren');
  finally
    DataTable.AfterLoadDFMValues;
  end;
end;

end.